import { type MCPServerInfo } from '../../types';

const InvideoServer: MCPServerInfo = {
  serverId: 'INVIDEO',
  name: 'InVideo',
  slug: 'invideo',
  description:
    "Transform text prompts into full-length videos with AI-generated scripts, visuals, voiceovers, and subtitles. Create publish-ready content for YouTube, TikTok, Instagram Reels, and other platforms on any topic using InVideo's comprehensive video generation workflow.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.invideo.io/sse',
    transport: 'SSE'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default InvideoServer;
